"use strict";

exports.__esModule = true;
exports.ReactModuleContainerContext = void 0;
var _react = require("react");
/** @deprecated `ReactModuleContainerContext` exists as a workaround while transitioning from legacy features, please do not use */
var ReactModuleContainerContext = exports.ReactModuleContainerContext = /*#__PURE__*/(0, _react.createContext)(null);
ReactModuleContainerContext.displayName = 'ReactModuleContainerContext(deprecated)';